(function () {
  const items = document.querySelectorAll('[data-accordion-title]');

  if (items.length) {
    items.forEach(item => {
      item.addEventListener('click', () => {
        const valueAttr = item.getAttribute('data-accordion-title');
        item.classList.toggle('open');
        document.querySelectorAll(`[data-accordion-text="${valueAttr}"]`).forEach(text => {
          text.classList.toggle('open');
        });
      });
    });
  }
})();